import React from 'react';
import shop from "shop/shop";
import { Button, Label, Modal, Pagination, Table, Icon } from "semantic-ui-react";
import Dropzone from "react-dropzone"
import _, { result } from "lodash"
import Papa from "papaparse"

class CSVUploader extends React.Component {


	state = {
		open: false
	}
  fileInputRef = React.createRef();
  


  fileChange ( files ) {
	let baseUrl = (process.env.BSHOP_BASE_URL || process.env.REACT_APP_API)
	if(!files[0]){
		console.log("ERROR")
		shop.toast( translate( "Fehler beim Import, bitte richtiges Format wählen!" ) )
		this.setState( {open: false} )
	}
	else{
		Papa.parse(files[ 0 ], {
			header: false,
			skipEmptyLines: false,
			complete: function (results) {
				console.log(results.data)
				if(results.data[0]){
					//console.log(results.data[0])
					if(results.data[0].toString() == "Artikelnummer"){
						console.log(results.data.length)
						var emptylinecounter = 0;
						for(var i = 0; i < results.data.length;i++){
							console.log(results.data[i].toString())
							if(results.data[i].toString() == ''){
								console.log("EMPTY LINE!")
								emptylinecounter++;
							}
							
						}
						console.log("REAL CSV FILE!")
						console.log(emptylinecounter)
						console.log(files[ 0 ])
						var updata = files[0]
						//var updata = this.fileInputRef.current.files[0]
						console.log(fetch(baseUrl + '/shop/rest/tables/import/ADENT/1?replace=1',{method: 'POST', body: updata, credentials: 'include' }));
						if(emptylinecounter > 1){
							shop.toast( results.data.length + " " + translate( "products successfully imported, though file contained ") + (emptylinecounter-1) + translate(" empty lines.") )
						}
						else{
							shop.toast( results.data.length + " " + translate( "products successfully imported" ) )
						}
						
						
					}
					else{
						shop.toast( translate( "Fehler beim Import, Kopfzeile entspricht nicht der Vorlage!" ) )
					}
				}
			},
		  });
		  this.setState( {open: false} )
	}
    
  }

	render() {
		const {open} = this.state
    const tblName = shop.session.handUser.extras.selections
    
		return (
			<a>
				<Button size={"tiny"} basic onClick={() => this.setState( {open: true} )}>{translate( "CSV hochladen" )}</Button>
				<Modal
					closeIcon={<Icon name="close" />}
					open={open}
					onClose={() => {
						this.setState( {open: false} )
					}}
					size="tiny">
            
					<Modal.Header>{translate( "Sortimente hochladen" )}</Modal.Header>
					<Modal.Content>
          <section className="Csv">
          <div className="dropzone">
			
          <Dropzone accept=".csv" style={{}} multiple={false} onDrop={this.fileChange.bind(this)}>
            <p>{translate("Datei hier platzieren")}</p>
          </Dropzone>
          </div></section>
					</Modal.Content>
				</Modal>
			</a>

		)
	}
}

export default CSVUploader;


// WEBPACK FOOTER //
// ./src/components/Budget/CSVUploader.js